import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// Dashboard
export const getDashboard = () => api.get("/dashboard");
export const getDashboardWeekly = (weekStart) => api.get("/dashboard/weekly", { params: { week_start: weekStart } });

// Backup & Restore
export const createBackup = () => api.get("/backup");
export const restoreBackup = (data) => api.post("/restore", data);

// Bulk Delete
export const bulkDeletePartite = (ids) => api.post("/partite/bulk-delete", ids);
export const bulkDeleteMovimenti = (ids) => api.post("/movimenti/bulk-delete", ids);
export const bulkDeleteFornitori = (ids) => api.post("/fornitori/bulk-delete", ids);
export const bulkDeleteClienti = (ids) => api.post("/clienti/bulk-delete", ids);
export const bulkDeleteProdotti = (ids) => api.post("/prodotti/bulk-delete", ids);

// Partite
export const getPartite = (params) => api.get("/partite", { params });
export const getPartita = (id) => api.get(`/partite/${id}`);
export const createPartita = (data) => api.post("/partite", data);
export const deletePartita = (id) => api.delete(`/partite/${id}`);

// Movimenti
export const getMovimenti = (params) => api.get("/movimenti", { params });
export const getMovimentiPartita = (partitaId) => api.get(`/movimenti/partita/${partitaId}`);
export const createMovimento = (data) => api.post("/movimenti", data);
export const deleteMovimento = (id) => api.delete(`/movimenti/${id}`);
export const updateMovimento = (id, data) => api.put(`/movimenti/${id}`, data);

// Fornitori
export const getFornitori = () => api.get("/fornitori");
export const createFornitore = (data) => api.post("/fornitori", data);
export const deleteFornitore = (id) => api.delete(`/fornitori/${id}`);
export const updateFornitore = (id, data) => api.put(`/fornitori/${id}`, data);

// Clienti
export const getClienti = () => api.get("/clienti");
export const createCliente = (data) => api.post("/clienti", data);
export const deleteCliente = (id) => api.delete(`/clienti/${id}`);
export const updateCliente = (id, data) => api.put(`/clienti/${id}`, data);

// Prodotti
export const getProdotti = () => api.get("/prodotti");
export const createProdotto = (data) => api.post("/prodotti", data);
export const deleteProdotto = (id) => api.delete(`/prodotti/${id}`);
export const updateProdotto = (id, data) => api.put(`/prodotti/${id}`, data);

// Partite con giacenza
export const getPartiteGiacenza = () => api.get("/partite/giacenza");

// Report
export const getReport = (params) => api.get("/report", { params });

// Stats
export const getStatsFornitore = (nome) => api.get(`/stats/fornitore/${encodeURIComponent(nome)}`);
export const getStatsCliente = (nome) => api.get(`/stats/cliente/${encodeURIComponent(nome)}`);

export default api;
